import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import dayjs from 'dayjs';

const SubscriptionAlert = inject('userStore', 'chargeStore','snackbarStore')(observer(({ userStore, chargeStore,snackbarStore }) => {


    useEffect(() => {
        // Skip subscription check if on subscription or invoice pages
        const currentPath = window.location.pathname;
        if (currentPath.includes('/user/info/subscriptions') || currentPath.includes('/user/info/invoice')) {
            return;
        }
        if( !userStore.subscriptionEndDate ) return
        let expireDay = dayjs(userStore.subscriptionEndDate)
        let now = dayjs()
        if ( now.isAfter(expireDay) ) {
            chargeStore.openChargeDialog(false)
            snackbarStore.showSnackbar('您的订阅已过期', "error")
        }else{
            let diffHours = expireDay.diff(now, 'hour')
            if( diffHours < 1 ) {
                let diffMins = expireDay.diff(now, 'minute')
                snackbarStore.showSnackbar(`您还有 ${diffMins} 分钟可以使用此平台`, "warning")
            } else if( diffHours < 24 ) {
                snackbarStore.showSnackbar(`您还有 ${diffHours} 小时可以使用此平台`, "warning")
            }else{
                let diff = expireDay.diff(now, 'day')
                if( diff < 10 ) {
                    snackbarStore.showSnackbar(`您还有 ${diff} 天可以使用此平台`, "warning")
                }
            }
        }

    }, [userStore.subscriptionEndDate,chargeStore,snackbarStore])

    return null
}))

export default SubscriptionAlert;
